// components/CalendarDayCell.jsx

import React from "react";

import CalendarEventPill from "./CalendarEventPill";

import {
  formatDayLong,
  isPastDay,
  isSameMonth,
  isToday,
  toDateKey,
} from "../utils/calendarUtils";

export default function CalendarDayCell({
  date,
  monthDate,
  events = [],
  onSelectEvent,
  onOpenDay,
  maxVisibleEvents = 3,
}) {
  const dateKey = toDateKey(date);

  const currentMonth = isSameMonth(
    date,
    monthDate
  );

  const today = isToday(date);
  const past = isPastDay(date);

  const isWeekend =
    date.getDay() === 0 || date.getDay() === 6;

  const visibleEvents = events.slice(
    0,
    maxVisibleEvents
  );

  const hiddenEventsCount = Math.max(
    events.length - visibleEvents.length,
    0
  );

  return (
    <article
      className={[
        "relative min-h-[170px] border-b border-r border-slate-200 p-2",
        "transition-colors dark:border-white/10",
        currentMonth
          ? "bg-white dark:bg-slate-900"
          : "bg-slate-100/70 dark:bg-slate-950/60",
        isWeekend && currentMonth
          ? "bg-slate-50/90 dark:bg-slate-900/75"
          : "",
        today
          ? "ring-2 ring-inset ring-red-500/40"
          : "",
      ].join(" ")}
    >
      <div className="mb-2 flex items-center justify-between gap-2">
        <button
          type="button"
          onClick={() => {
            if (events.length > 0) {
              onOpenDay?.(date, events);
            }
          }}
          title={
            events.length > 0
              ? `Afficher les événements du ${formatDayLong(
                  date
                )}`
              : formatDayLong(date)
          }
          className={[
            "inline-flex h-7 min-w-7 items-center justify-center rounded-full px-1.5 text-sm font-black",
            "transition",
            today
              ? "bg-red-600 text-white shadow-md shadow-red-600/20"
              : currentMonth
              ? "text-slate-900 hover:bg-slate-100 dark:text-white dark:hover:bg-white/10"
              : "text-slate-400 dark:text-slate-600",
            past && currentMonth && !today
              ? "opacity-70"
              : "",
          ].join(" ")}
        >
          {date.getDate()}
        </button>

        {events.length > 0 && (
          <span className="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-slate-100 px-1 text-[9px] font-black text-slate-500 dark:bg-white/10 dark:text-slate-300">
            {events.length}
          </span>
        )}
      </div>

      <div className="space-y-1.5">
        {visibleEvents.map((event) => (
          <CalendarEventPill
            key={`${dateKey}-${event.id}`}
            event={event}
            dateKey={dateKey}
            onClick={onSelectEvent}
          />
        ))}
      </div>

      {hiddenEventsCount > 0 && (
        <button
          type="button"
          onClick={() =>
            onOpenDay?.(date, events)
          }
          className={[
            "mt-1.5 w-full rounded-lg px-2 py-1.5 text-left",
            "text-[10px] font-black text-red-600",
            "transition hover:bg-red-50",
            "dark:text-red-400 dark:hover:bg-red-950/30",
          ].join(" ")}
        >
          + {hiddenEventsCount} autre
          {hiddenEventsCount > 1 ? "s" : ""}
        </button>
      )}
    </article>
  );
}